module.exports = __webpack_public_path__ + "img/yunpub.ff6ad260.png";